import { type RefObject, useEffect } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { stopEscKeyPropagationOnAssetDetailsModal } from '~/components/AssetModal/shared/hooks/useAssetModalEscKeyHandler';
import { type PDFSearchInputHandle } from '~/components/AssetModal/Visualizer/PDFVisualizer/PDFSearch/components/PDFSearchInput';

type UsePDFSearchHotkeysParams = {
  openSearch: () => void;
  closeSearch: () => void;
  showNextResult: () => void;
  showPreviousResult: () => void;
  isExpanded: boolean;
  inputRef: RefObject<PDFSearchInputHandle>;
};

export const usePDFSearchHotkeys = ({
  openSearch,
  closeSearch,
  isExpanded,
  showPreviousResult,
  showNextResult,
  inputRef,
}: UsePDFSearchHotkeysParams) => {
  useEffect(() => {
    stopEscKeyPropagationOnAssetDetailsModal(isExpanded);
  }, [isExpanded]);

  useHotkeys(
    'ctrl+f,meta+f',
    () => {
      openSearch();
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
    },
  );

  useHotkeys(
    'esc',
    () => {
      closeSearch();
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
      enabled: isExpanded,
    },
  );

  useHotkeys(
    'enter',
    () => {
      if (inputRef.current?.getIsFocused()) {
        showNextResult();
      }
    },
    {
      enableOnFormTags: true,
    },
  );

  useHotkeys(
    'shift+enter',
    () => {
      if (inputRef.current?.getIsFocused()) {
        showPreviousResult();
      }
    },
    {
      enableOnFormTags: true,
    },
  );

  useHotkeys(
    'meta+g,ctrl+g',
    () => {
      showNextResult();
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
    },
  );

  useHotkeys(
    'meta+shift+g,ctrl+shift+g',
    () => {
      showPreviousResult();
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
    },
  );
};
